<template>
  <div class="licenses">
    <h1 class="title">Licenses in use:</h1>
    <div class="licenses-container">
      <license v-for="(l, ind) in licenses" :license="l" :key="ind"></license>
    </div>
  </div>
</template>

<script>
import License from "../License.vue";

export default {
  name: "SquaredDilemmaLicenses",
  components: {
    license: License,
  },
  data() {
    return {
      licenses: [
        {
          resDescription: "arrow, back icon",
          resUrl:
            "https://freeicons.io/material-icons-navigation-2/arrow-back-icon-16674",
          author: "icon king1",
          authorUrl: "https://freeicons.io/profile/3",
          licenseName: "Attribution 3.0 Unported (CC BY 3.0)",
          licenseUrl: "https://creativecommons.org/licenses/by/3.0/",
        },
        {
          resDescription: "replay icon",
          resUrl: "https://freeicons.io/material-icons-alert-and-av/replay-icon-16088",
          author: "icon king1",
          authorUrl: "https://freeicons.io/profile/3",
          licenseName: "Attribution 3.0 Unported (CC BY 3.0)",
          licenseUrl: "https://creativecommons.org/licenses/by/3.0/",
        },
        {
          resDescription: "home icon",
          resUrl: "https://freeicons.io/material-icons-action/home-icon-15944",
          author: "icon king1",
          authorUrl: "https://freeicons.io/profile/3",
          licenseName: "Attribution 3.0 Unported (CC BY 3.0)",
          licenseUrl: "https://creativecommons.org/licenses/by/3.0/",
        },
        {
          resDescription: "idea icon",
          resUrl: "https://freeicons.io/test/idea-icon-icon",
          author: "icon king1",
          authorUrl: "https://freeicons.io/profile/3",
          licenseName: "Attribution 3.0 Unported (CC BY 3.0)",
          licenseUrl: "https://creativecommons.org/licenses/by/3.0/",
        },
        {
          resDescription: "play, arrow icon",
          resUrl:
            "https://freeicons.io/material-icons-alert-and-av/play-arrow-icon-16061",
          author: "icon king1",
          authorUrl: "https://freeicons.io/profile/3",
          licenseName: "Attribution 3.0 Unported (CC BY 3.0)",
          licenseUrl: "https://creativecommons.org/licenses/by/3.0/",
        },
        {
          resDescription: "essentials, hand, click, point icon",
          resUrl:
            "https://freeicons.io/line-hero-essentials/essentials-hand-click-point-icon-20454",
          author: "www.wishforge.games",
          authorUrl: "https://freeicons.io/profile/2257",
          licenseName: "Free for commercial use(Include link to authors website)",
          licenseUrl: "https://www.wishforge.games/",
        },
        {
          resDescription: "computers, and, hardware, speaker, audio, sound, loud icon",
          resUrl:
            "https://freeicons.io/computers-and-hardware-2/computers-and-hardware-speaker-audio-sound-loud-icon-42272",
          author: "www.wishforge.games",
          authorUrl: "https://freeicons.io/profile/2257",
          licenseName: "Free for commercial use(Include link to authors website)",
          licenseUrl: "https://www.wishforge.games/",
        },
        {
          resDescription: "faq, help desk, info center, information, support icon",
          resUrl:
            "https://freeicons.io/e-commerce-and-shopping/faq-help-desk-info-center-information-support-icon-38298",
          author: "MD Badsha Meah",
          authorUrl: "https://freeicons.io/profile/3335",
          licenseName: "Attribution 3.0 Unported (CC BY 3.0)",
          licenseUrl: "https://creativecommons.org/licenses/by/3.0/",
        },
        {
          resDescription:
            "customer feedback, customer satisfaction, like, rating, review, thumbs up icon",
          resUrl:
            "https://freeicons.io/insurance/customer-feedback-customer-satisfaction-like-rating-review-thumbs-up-icon-38454",
          author: "MD Badsha Meah",
          authorUrl: "https://freeicons.io/profile/3335",
          licenseName: "Attribution 3.0 Unported (CC BY 3.0)",
          licenseUrl: "https://creativecommons.org/licenses/by/3.0/",
        },
        {
          resDescription: "gear, settings, setting, wheel icon",
          resUrl:
            "https://freeicons.io/free-setting-and-configuration-icons/gear-settings-setting-wheel-icon-9576",
          author: "Raj Dev",
          authorUrl: "https://freeicons.io/profile/714",
          licenseName: "Attribution 3.0 Unported (CC BY 3.0)",
          licenseUrl: "https://creativecommons.org/licenses/by/3.0/",
        },
        {
          resDescription: "icon, sun icon",
          resUrl: "https://freeicons.io/filed-weather-icons/icon-sun-icon-6660",
          author: "Raj Dev",
          authorUrl: "https://freeicons.io/profile/714",
          licenseName: "Attribution 3.0 Unported (CC BY 3.0)",
          licenseUrl: "https://creativecommons.org/licenses/by/3.0/",
        },
        {
          resDescription: "podium, position, rank, winner, leaderboard icon",
          resUrl:
            "https://freeicons.io/office-and-business-4/podium-position-rank-winner-leaderboard-icon-111983",
          author: "ColourCreatype",
          authorUrl: "https://freeicons.io/profile/5790",
          licenseName: "Attribution-NonCommercial 3.0 Unported (CC BY-NC 3.0)",
          licenseUrl: "https://creativecommons.org/licenses/by-nc/3.0/",
        },
        {
          resDescription: "moon icon",
          resUrl: "https://freeicons.io/ios-edge-glyph/moon-icon-29411",
          author: "Fasil",
          authorUrl: "https://freeicons.io/profile/722",
          licenseName: "Attribution 3.0 Unported (CC BY 3.0)",
          licenseUrl: "https://creativecommons.org/licenses/by/3.0/",
        },
        {
          resDescription: "rank icon",
          resUrl: "https://freeicons.io/business-8/rank-icon-51812",
          author: "Lima Studio",
          authorUrl: "https://freeicons.io/profile/6195",
          licenseName: "Attribution 3.0 Unported (CC BY 3.0)",
          licenseUrl: "https://creativecommons.org/licenses/by/3.0/",
        },
        // Sounds
        {
          resDescription: "game over03.wav",
          resUrl: "https://freesound.org/people/notchfilter/sounds/43698/",
          author: "notchfilter",
          authorUrl: "https://freesound.org/people/notchfilter/",
          licenseName: "Attribution 3.0 Unported (CC BY 3.0)",
          licenseUrl: "https://creativecommons.org/licenses/by/3.0/",
        },
        {
          resDescription: "Jingle_Achievement_00.wav",
          resUrl: "https://freesound.org/people/LittleRobotSoundFactory/sounds/270404/",
          author: "LittleRobotSoundFactory",
          authorUrl: "https://freesound.org/people/LittleRobotSoundFactory/",
          licenseName: "Attribution 3.0 Unported (CC BY 3.0)",
          licenseUrl: "https://creativecommons.org/licenses/by/3.0/",
        },
        {
          resDescription: "Cartoon UI Back/Cancel",
          resUrl: "https://freesound.org/people/plasterbrain/sounds/423168/",
          author: "plasterbrain",
          authorUrl: "https://freesound.org/people/plasterbrain/",
          licenseName: "CC0 1.0 Universal (CC0 1.0) Public Domain Dedication",
          licenseUrl: "https://creativecommons.org/publicdomain/zero/1.0/",
        },
        {
          resDescription: "building placement.WAV",
          resUrl: "https://freesound.org/people/strange_dragoon/sounds/271134/",
          author: "strange_dragoon",
          authorUrl: "https://freesound.org/people/strange_dragoon/",
          licenseName: "Attribution 3.0 Unported (CC BY 3.0)",
          licenseUrl: "https://creativecommons.org/licenses/by/3.0/",
        },
        {
          resDescription: "Pop 1 (4)",
          resUrl: "https://freesound.org/people/Sheyvan/sounds/567273/",
          author: "Sheyvan",
          authorUrl: "https://freesound.org/people/Sheyvan/",
          licenseName: "CC0 1.0 Universal (CC0 1.0) Public Domain Dedication",
          licenseUrl: "https://creativecommons.org/publicdomain/zero/1.0/",
        },
        {
          resDescription: "Live Swoosh_01.wav",
          resUrl: "https://freesound.org/people/s-cheremisinov/sounds/402183/",
          author: "s-cheremisinov",
          authorUrl: "https://freesound.org/people/s-cheremisinov/",
          licenseName: "CC0 1.0 Universal (CC0 1.0) Public Domain Dedication",
          licenseUrl: "https://creativecommons.org/publicdomain/zero/1.0/",
        },
        // Libraries
        {
          resDescription: "Konfetti",
          resUrl: "https://github.com/DanielMartinus/konfetti",
          author: "Dion Segijn",
          authorUrl: "https://github.com/DanielMartinus",
          licenseName: "ISC license",
          licenseUrl: "https://github.com/DanielMartinus/Konfetti/blob/main/LICENSE",
        },
      ],
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.title {
  text-align: center;
}
.licenses-container {
  box-sizing: border-box;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  row-gap: 3px;
  column-gap: 3px;
}
</style>
